export const VideoPage_Data = {
    "luzon-blinds": {

        // Page Meta Fields
        META_PG_OG_Title: 'Luzon Blinds | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/luzon-blinds/',

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/Of71JGb0djo?si=JdGVDs6IhI7z68X8",
        VID_info_title: "Luzon Blinds",
        VID_info_dec: "Callistus Luzon Blinds combine alternating sheer and solid fabric bands in a single shade. Stunningly eye catching stripes features the ideal balance of Light and Privacy for your window Furnishings designs and create the perfect look for your interiors.",
        VID_Suggestions: 1,
        VID_Current_index: 1,
    },
    "colby-blinds-by-callistus-window-fashion": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Blinds by Callistus Window Fashion | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/colby-blinds-by-callistus-window-fashion/',

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/RjKXvRbFzcA?si=_J5N4AliTgcOeIXT",
        VID_info_title: "Colby Blinds by Callistus Window Fashion",
        VID_info_dec: "Most energy efficient blinds specifically engineered to provide beauty and Luxury Callistus Colby blind combines soft, seamless fabrics with crisp uniform pleats that hold the shape indefinitely. Choose Top-down / Bottom-up and open your shades from the top, bottom, or both. While Choosing Day & Night Control Light as you desire.",
        VID_Suggestions: 1,
        VID_Current_index: 2,
    },
    "callistus-panel-blinds": {

        // Page Meta Fields
        META_PG_OG_Title: 'Callistus Panel Blinds | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/callistus-panel-blinds/',

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/NgCKHVWvYsA?si=SQyBQBjL4XWCy27N",
        VID_info_title: "Callistus Panel Blinds",
        VID_info_dec: "Make a statement and enhance your space with Callistus Panel blinds Transform your space with contemporary Panel Blinds. Callistus Panel blinds offer a sleek answer for both large and small window expanses. Open, they stack compactly to offer the maximum view; closed, they display their rich fabrics, colour and texture. Panel blinds are an ideal choice for those who want to make an impact and add something a little different to their interior. With their flexible nature, not only do they make a lustrous window decoration for larger windows, bi-fold or patio doors, but they are a fantastic choice for room dividers as well. Dazzling choice of fabrics with 550+ awesome designs and colours",
        VID_Suggestions: 1,
        VID_Current_index: 3,
    },
    "new-window-nice": {

        // Page Meta Fields
        META_PG_OG_Title: 'Grayson Blinds | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/new-window-nice/',

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/KWtg1kHz9_Q?si=YwGEQRP7q9CIpti2",
        VID_info_title: "Grayson Blinds",
        VID_info_dec: "Callistus Grayson blinds gives you ultimate privacy with a view to the outside. It easily creates beautiful gradations of light like Venetian blinds with Soft fabric vanes suspended between two sheers, diffusing softened light deep into a room. Tilt the vanes to enjoy the lighting you desire.",
        VID_Suggestions: 1,
        VID_Current_index: 4,
    },
    "wooden-venetian": {

        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Blinds | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/wooden-venetian/',

        VID_Col1_title: "Product",
        VID_embed_src: "https://www.youtube.com/embed/Mlvmsv_g6xQ?si=7IWvEojYJE6mPU6w",
        VID_info_title: "Wooden Venetian Blinds",
        VID_info_dec: "Add a contemporary feel to your Interiors with Callistus Wooden Venetian blinds and experience timeless luxury. Choose from a Unique collection of Faux Metallic & Natural Basswood series to complete the elegance of your home decor. With an array of ladder tape colours help define your Wooden Venetian design and add extra style to Window fashion.",
        VID_Suggestions: 1,
        VID_Current_index: 5,
    },
    "wooden-venetian-manual": {

        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Manual | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/wooden-venetian-manual/',

        VID_Col1_title: "Operating System",
        VID_embed_src: "https://www.youtube.com/embed/nloVJy8-I7E?si=3ZehQKcvrMLLWC80",
        VID_info_title: "Wooden Venetian Manual",
        VID_info_dec: "One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.",
        VID_Suggestions: 2,
        VID_Current_index: 1
    },
    "roller-blinds-one-touch-up": {

        // Page Meta Fields
        META_PG_OG_Title: 'Roller Blinds One Touch Up | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/roller-blinds-one-touch-up/',

        VID_Col1_title: "Operating System",
        VID_embed_src: "https://www.youtube.com/embed/eMponETwg2w?si=Yuy48TNcC6DYgeFj",
        VID_info_title: "Roller Blinds One Touch Up",
        VID_info_dec: "One Touch Up is a smart system wherein you just need to pull the operating cord, and the blind will roll up on its own.",
        VID_Suggestions: 2,
        VID_Current_index: 2
    },
    "colby-blinds-top-down-bottom-up-tdbu": {

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Blinds Top Down Bottom Up (TDBU) | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/colby-blinds-top-down-bottom-up-tdbu/',

        VID_Col1_title: "Operating System",
        VID_embed_src: "https://www.youtube.com/embed/watjP8y3TE8?si=RBYDWa9RBWGnzCUd",
        VID_info_title: "Colby Blinds Top Down Bottom Up (TDBU)",
        VID_info_dec: "Callistus Colby Blind Top-Down/Bottom-Up system offers you the ability to operate window blind from the top down or the bottom up to meet all your privacy needs while still giving you access to natural light.",
        VID_Suggestions: 2,
        VID_Current_index: 3
    },
    "patricia-blind-automation": {

        // Page Meta Fields
        META_PG_OG_Title: 'Patricia Blind Automation | Callistus Blinds',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/videos/patricia-blind-automation/',

        VID_Col1_title: "Patricia Blind Automation",
        VID_embed_src: "https://www.youtube.com/embed/PnCvR2s1OiA?si=7s8lo1iIEXJBaVZC",
        VID_info_title: "Patricia Blind Automation",
        VID_info_dec: "The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.",
        VID_Suggestions: 2,
        VID_Current_index: 4
    },
}